
import { config as fetcherConfig } from '@matchlighter/fetcher';
import axios, { Axios, AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import deepEqual from 'deep-eql';

import { urlJoin } from '@matchlighter/common_library/lib/strings';

import { csrfToken, env } from './environment';

function isSomeHttpError(err: Error): err is AxiosError {
    return (err as any).response !== undefined;
}

export function isHttpError(err: Error, code?: number | string | RegExp): err is AxiosError {
    if (isSomeHttpError(err)) {
        if (!code) return true;

        if (typeof code == 'number') return err.response.status == code;
        if (typeof code == 'string') code = new RegExp(`^${code.replace(/x/g, '\\d')}$`);

        return code.test(String(err.response.status));
    } else {
        return false;
    }
}

export async function compareRequests(reqParams: AxiosRequestConfig, lastResponse?: AxiosResponse) {
    if (lastResponse && lastResponse.config.url == reqParams.url && deepEqual(reqParams.params, lastResponse.config.params)) {
        return lastResponse;
    } else {
        return await API.request(reqParams)
    }
}

export class APIBase extends Axios {
    constructor(config: (AxiosRequestConfig & { subURL?: string }) = {}) {
        super({
            ...axios.defaults,
            baseURL: `/organizations/${env.organization_id}/${config.subURL || ''}`,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-Token': csrfToken,
                'Authorization': 'token=' + env.session_key
            },
            withCredentials: true,
            ...config,
        })
    }

    get base_url() {
        return this.defaults.baseURL;
    }

    request<T = any, R = AxiosResponse<T, any>, D = any>(config: AxiosRequestConfig<D>): Promise<R> {
        if (config.data instanceof FormData) {
            config.headers ||= {}
            config.headers['Content-Type'] = 'multipart/form-data';
        }
        return super.request(config)
    }


    create_href(to: string) {
        return `${this.base_url}${to}?session_key=${env.session_key}`;
    }

    saveModel(url, data, id = data.id) {
        return API.request({
            method: id ? 'PUT' : 'POST',
            url: urlJoin(url, id || ''),
            data,
        })
    }

}

export function saveApiModel(url, data, id?) {
    return API.saveModel(url, data, id)
}

export const API = new APIBase();
fetcherConfig.api.backend = API
